/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { createContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import mbpLogger from 'mbp-logger';

import useFetchAPI from '../../../common/customHooks/useFetchAPI';
import { isEmpty } from '../../../utils/object';
import { getIsAuthenticatedStatus } from '../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import fetchOrderDetailsV2API from '../../../../../../apis/order-apis/fetchOrderDetailsV2';

const OrderDetailsContext = createContext(null);

const OrderDetailsContextProvider = ({ children }) => {
    const history = useHistory();

    // fetching ross data from session storage for guest user, this data is available on session storage only for guest user
    const ROSSOrderFromSession = JSON.parse(sessionStorage.getItem('ROSSOrder'));
    const orderDataLoadedFromSession = sessionStorage.getItem('orderDetailsLoaded');

    const [errorMessage, setErrorMessage] = useState('');
    const [ROSSOrder, setRossOrders] = useState(ROSSOrderFromSession || {});
    const [orderDataLoaded, setOrderDataLoaded] = useState(orderDataLoadedFromSession || false);
    const [uuid, setUuid] = useState('');

    const isAuthenticatedStatus = useSelector(getIsAuthenticatedStatus);
    const isFirstLoad = sessionStorage.getItem('isFirstLoad');

    const getUuid = (id) => {
        setUuid(id);
    };

    const onSuccess = ({ data }) => {
        sessionStorage.removeItem('ROSSOrder');
        sessionStorage.removeItem('orderDetailsLoaded');
        const ROSSOrder = data;
        ROSSOrder.uuid = uuid;
        if (!isEmpty(ROSSOrder)) {
            if (isEmpty(ROSSOrder.orders)) {
                setErrorMessage('Unable to obtain order details for this order.');
                setOrderDataLoaded(true);
                if (isAuthenticatedStatus) {
                    // If users already logged in and they couldn't get any order that associated to their account,
                    // we'll redirect them to /account/orders page
                    history.push('/account/orders');
                }
            } else {
                setOrderDataLoaded(true);
                setRossOrders(ROSSOrder);
                if (!isAuthenticatedStatus && !isFirstLoad) {
                    sessionStorage.setItem('ROSSOrder', JSON.stringify(ROSSOrder));
                    sessionStorage.setItem('orderDetailsLoaded', true);
                }
            }
        }
    };

    const onError = (err) => {
        setErrorMessage(`error fetching ROSS orders by details v2: ${err}`);
        setOrderDataLoaded(true);
        mbpLogger.logError({
            function: 'createFetchOrderDetailsMutation',
            appName: process.env.npm_package_name,
            module: 'OrderDetails',
            message: errorMessage,
        });
    };

    const createFetchOrderDetailsMutation = useFetchAPI(onSuccess, onError, fetchOrderDetailsV2API, true);

    const data = {
        createFetchOrderDetailsMutation,
        ROSSOrder,
        orderDataLoaded,
        setErrorMessage,
        errorMessage,
        getUuid,
    };

    return (
        <OrderDetailsContext.Provider value={data}>
            {children}
        </OrderDetailsContext.Provider>
    );
};

export { OrderDetailsContextProvider, OrderDetailsContext };
